// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationConversionPath = 'M1.925 5h96.152L67.65 41.487a17.66 17.66 0 00-4.097 8.988L61.966 60h-7.381a5 5 0 11-9.168 0h-7.381l-1.598-9.588a17.656 17.656 0 00-4.125-8.97L1.925 5zm60.388 31.959L83.123 12H16.878L37.65 36.913a24.557 24.557 0 015.626 11.925l.077.487.613 3.675h12.07l.602-3.612a24.56 24.56 0 015.356-12.053l.319-.377zM46 25a5 5 0 11-10 0 5 5 0 0110 0zm13 2a5 5 0 100-10 5 5 0 000 10zm-9 54a5 5 0 100-10 5 5 0 000 10zm5 9a5 5 0 11-10 0 5 5 0 0110 0zm-4-49a5 5 0 100-10 5 5 0 000 10z';
var IllustrationConversion = baseIllustration('IllustrationConversion', {
  getPath: () => IllustrationConversionPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationConversion;
//# sourceMappingURL=index.js.map